import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";

function toPascalCase(w) {
  return w[0].toUpperCase() + w.slice(1).toLowerCase();
}

function getHeaders(languages, systemColors) {
  const headers = [
    new InMemoryHeader({
      type: new InMemoryString("Identifier"),
      visible: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new InMemoryHeader({
      title: "headers.memberdependants.id",
      type: new InMemoryString("Id", {
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.category",
      type: new InMemoryString("Category"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.member_groups",
      type: new InMemoryString("MemberTypes", {
        getString: (item) => {
          if (item.MemberTypes === null || item.MemberTypes === undefined) {
            return "";
          }
          return item.MemberTypes.join(", ");
        },
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "views.downloadcenter.icon",
      type: new InMemoryString("Icon", {
        getHtml: (item, type) => {
          return `<i class="v-icon notranslate mdi theme--light ${item.Icon}"></i><span style="margin-left:5px">${item.Icon}</span>`;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "globals.color",
      type: new InMemoryString("Color", {
        getHtml: (item, type) => {
          if (item.Color === null || item.Color === undefined) {
            return "";
          }
          const keys = Object.keys(systemColors).filter(
            (o) => o.toLowerCase() === item.Color.toLowerCase(),
          );
          if (keys.length > 0) {
            const index = keys[0];
            return `<div style="background-color:${systemColors[index]};width:20px;height:10px;display: inline-table;"></div><span style="margin-left:5px">${item.Color}</span>`;
          }
          return `<div style="background-color:${item.Color};width:20px;height:10px;display: inline-table;"></div><span style="margin-left:5px">${item.Color}</span>`;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.members_wizard.Status",
      type: new InMemoryString("Status"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new InMemoryHeader({
      title: "headers.plan_notifications.type",
      type: new InMemoryString("Type"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];

  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.plan_notifications.title_{0}`, [
          lang.language.toUpperCase(),
        ]),
        type: new InMemoryString(`Title${toPascalCase(lang.language)}`),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      }),
    );
  }

  for (const lang of languages) {
    headers.push(
      new InMemoryHeader({
        title: i18n.t(`headers.plan_notifications.text_{0}`, [
          lang.language.toUpperCase(),
        ]),
        type: new InMemoryString(`Text${toPascalCase(lang.language)}`),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
      }),
    );
  }
  headers.push(
    new InMemoryHeader({
      title: "headers.plan_notifications.start_date",
      type: new InMemoryDate("StartDate"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new InMemoryHeader({
      title: "headers.plan_notifications.end_date",
      type: new InMemoryDate("EndDate"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new InMemoryHeader({
      title: "headers.plan_notifications.date_uploaded",
      type: new InMemoryDate("DateCreated"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new InMemoryHeader({
      title: "headers.plan_notifications.date_read",
      type: new InMemoryDate("DateRead"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  );

  return headers;
}
export default getHeaders;
